<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :header="null"
    @cancel="closeModal"
    wrapClassName="act-now-contact-modal"
  >
    <div class="act-now-contact-container">
      <div class="act-now-contact-container__header">
        <h1 class="act-now-contact-container__header--title">
          {{ regionTitle }}
        </h1>
      </div>

      <div class="act-now-contact-container__body">
        <div
          v-for="(contacts, category) in pakistanData"
          :key="category"
          class="act-now-contact-container__body--contact-category"
        >
          <h2 class="act-now-contact-container__body--contact-category--title">
            {{ category }}
          </h2>
          <a-row :gutter="[16, 16]">
            <a-col
              v-for="(contact, index) in contacts"
              :key="index"
              :xs="24"
              :sm="12"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <div class="contact-card" :class="{ selected: contact.selected }">
                <div class="contact-card__header">
                  <h3>{{ contact.name }}</h3>
                  <a-checkbox v-model:checked="contact.selected" />
                </div>
                <div class="contact-card__body">
                  <div
                    class="contact-card__body--contact-field"
                    v-if="contact.phone"
                  >
                    <img
                      src="@/assets/icons/telephone-icon.png"
                      alt="Phone"
                      class="icon"
                      style="width: 1.5rem;"
                    />
                    <p>{{ contact.phone }}</p>
                    <button
                      class="copy-btn"
                      @click="
                        copyToClipboard(contact.phone, category, index, 'phone')
                      "
                    >
                      <img src="@/assets/icons/copy-icon.png" alt="Copy" />
                      <div
                        class="copied"
                        v-if="copiedStates[`${category}-${index}-phone`]"
                      >
                        <p>Copied!</p>
                      </div>
                    </button>
                  </div>

                  <div
                    class="contact-card__body--contact-field"
                    v-if="contact.email"
                  >
                    <img
                      src="@/assets/icons/email-icon.png"
                      alt="Email"
                      class="icon"
                    />
                    <p>{{ contact.email }}</p>
                    <button
                      class="copy-btn"
                      @click="
                        copyToClipboard(contact.email, category, index, 'email')
                      "
                    >
                      <img src="@/assets/icons/copy-icon.png" alt="Copy" />
                      <div
                        class="copied"
                        v-if="copiedStates[`${category}-${index}-email`]"
                      >
                        <p>Copied!</p>
                      </div>
                    </button>
                  </div>

                  <div
                    class="contact-card__body--contact-field"
                    v-if="contact.address"
                  >
                    <img
                      src="@/assets/icons/address-icon.png"
                      alt="Address"
                      class="icon"
                    />
                    <p>{{ contact.address }}</p>
                  </div>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="act-now-contact-container__footer">
        <a-button @click="chatAi()">Generate Example Letter With Glocal AI</a-button>
      </div>
    </div>
  </a-modal>
  <ActNowChatAi
    :visible="visibleActNowChatAiModal"
    @handle-close="visibleActNowChatAiModal = false"
  />
</template>

<script>
import ActNowChatAi from "./ActNowChatAi.vue";

export default {
  props: {
    visible: Boolean,
    regionTitle: {
      type: String,
      default: "Pakistan",
    },
  },
  components: {
    ActNowChatAi,
  },
  data() {
    return {
      visibleActNowChatAiModal: false,
      copiedStates: {},
      pakistanData: {
        Senators: [
          {
            name: "Ashton Will",
            phone: "555-1001",
            email: "ashton.will@senate.pk",
            address: "Senate Building, Islamabad",
            selected: false,
          },
          {
            name: "Alice Darlin",
            phone: "555-1002",
            email: "alice.darlin@senate.pk",
            address: "Senate Building, Islamabad",
            selected: false,
          },
        ],
        Congressmembers: [
          {
            name: "Ashton Will",
            phone: "555-2001",
            email: "ashton.will@congress.pk",
            address: "Congress House, Islamabad",
            selected: false,
          },
          {
            name: "Alice Darlin",
            phone: "555-2002",
            email: "alice.darlin@congress.pk",
            address: "Congress House, Islamabad",
            selected: false,
          },
        ],
        Governor: [
          {
            name: "John Wick",
            phone: "555-3001",
            email: "john.wick@gov.pk",
            address: "Governor House, Islamabad",
            selected: false,
          },
        ],
        "City Councilmember": [
          {
            name: "Ashton Will",
            phone: "555-4001",
            email: "ashton.will@city.pk",
            address: "City Hall, Karachi",
            selected: false,
          },
          {
            name: "Alice Darlin",
            phone: "555-4002",
            email: "alice.darlin@city.pk",
            address: "City Hall, Lahore",
            selected: false,
          },
        ],
        "Wildlife Rescue League": [
          {
            name: "Wildlife Rescue League",
            phone: "555-5001",
            email: "rescue@wildlife.pk",
            address: "123 Forest Ave, Islamabad",
            selected: false,
          },
        ],
        "Wildlife SOS": [
          {
            name: "Wildlife SOS",
            phone: "555-5002",
            email: "help@wildlifesos.pk",
            address: "456 Nature Rd, Lahore",
            selected: false,
          },
        ],
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit("handle-close", false);
      this.selected = false;
    },
    copyToClipboard(text, category, index, fieldType) {
      const key = `${category}-${index}-${fieldType}`;

      // Set this specific field as copied
      this.copiedStates[key] = true;

      navigator.clipboard
        .writeText(text)
        .then(() => {
          setTimeout(() => {
            this.copiedStates[key] = false;
          }, 1000);
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
        });
    },
    chatAi() {
      this.visibleActNowChatAiModal = true;
      this.closeModal();
    },
  },
};
</script>

<style lang="scss">
.act-now-contact-modal {
  .ant-modal {
    width: 70rem !important;
    top: 8rem;

    .ant-modal-content {
      padding: 0;
      background-color: rgb(246, 248, 255);

      .ant-modal-close {
        margin: 2rem 1.8rem 0 0;
      }

      .ant-modal-body {
        .act-now-contact-container {
          &__header {
            padding: 2.5rem 2.5rem 0;
            &--title {
              font-size: 2.5rem;
              font-family: $font-primary-bold;
              color: $color-black;
              margin-bottom: 0;
            }
          }

          &__body {
            margin-top: 2rem;
            padding: 0 2.5rem;
            max-height: calc(100vh - 36rem);
            overflow-y: auto;
            overflow-x: hidden;
            &--contact-category {
              margin-bottom: 2rem;
              &--title {
                font-size: 2rem;
                font-family: $font-primary-medium;
                color: $color-black;
                margin-bottom: 1rem;
                line-height: normal;
              }

              .contact-card {
                border: 1px solid $color-dark-grey-5;
                background-color: $color-white;
                border-radius: 1rem;
                transition: box-shadow 0.3s;

                &.selected {
                  box-shadow: 0 0 0 1px $color-primary;
                }

                &__header {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 1.2rem 1.5rem 1rem;
                  position: relative;

                  &::before {
                    content: "";
                    height: 2px;
                    width: 92%;
                    position: absolute;
                    bottom: -0.2rem;
                    right: 4%;
                    background-color: #cdcdcd6b;
                  }

                  h3 {
                    font-size: 1.6rem;
                    font-family: $font-primary-medium;
                    color: $color-black;
                    margin-bottom: 0;
                  }

                  .ant-checkbox-wrapper {
                    .ant-checkbox {
                      .ant-checkbox-inner {
                        height: 1.6rem;
                        width: 1.6rem;
                        border: 1px solid $color-dark-grey-4;
                        &::after {
                          width: 0.6rem;
                          height: 0.9rem;
                        }
                      }
                    }
                  }
                  .ant-checkbox-wrapper-checked {
                    .ant-checkbox-checked {
                      .ant-checkbox-inner {
                        height: 1.6rem;
                        width: 1.6rem;
                        background-color: $color-primary;
                        border-color: $color-primary;
                      }
                    }
                  }
                }

                &__body {
                  padding: 1.5rem;
                  display: flex;
                  flex-direction: column;
                  gap: 0.8rem;

                  &--contact-field {
                    display: flex;
                    align-items: center;
                    gap: 0.7rem;
                    p {
                      font-size: 1.4rem;
                      font-family: $font-primary;
                      color: $color-black;
                      margin-bottom: 0;
                      opacity: 0.7;
                      display: flex;
                      align-items: center;
                      gap: 0.7rem;
                    }
                    .icon {
                      width: 1.6rem;
                      height: auto;
                    }

                    .copy-btn {
                      border: none;
                      outline: none;
                      border-radius: 0.5rem;
                      width: 2rem;
                      height: 2rem;
                      background-color: #8080803d;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                      margin-left: 0.3rem;
                      position: relative;
                      img {
                        width: 1rem;
                        height: auto;
                      }
                      .copied {
                        position: absolute;
                        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
                        bottom: 0;
                        padding: 0.5rem 1rem;
                        border-radius: 0.5rem;
                        z-index: 1;
                        background-color: $color-white;
                        right: -6rem;
                        p {
                          font-size: 1rem;
                          font-family: $font-primary;
                          margin-bottom: 0;
                          line-height: normal;
                        }
                      }
                    }
                  }
                }
              }
            }
            &::-webkit-scrollbar {
              width: 0.4rem;
              height: 0.4rem;
            }

            &::-webkit-scrollbar-track {
              background-color: transparent;
              border-radius: 0.8rem;
            }

            &::-webkit-scrollbar-thumb {
              background-color: $color-primary;
              border-radius: 0.8rem;
            }
          }

          &__footer {
            display: grid;
            grid-template-columns: 1fr;
            align-items: center;
            justify-content: space-between;
            gap: 1.5rem;
            padding: 2.5rem;
            .ant-btn {
              width: 100%;
              background-color: $color-primary;
              border: none;
              outline: none;
              height: auto;
              font-size: 1.6rem;
              font-family: $font-primary-medium !important;
              color: $color-white;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 1rem 1.5rem;
              white-space: inherit;

              span {
                line-height: 2rem;
              }

              .anticon {
                .anticon-spin {
                  font-size: 1.8rem;
                  color: $color-primary;
                }
              }

              &:hover,
              &:focus {
                background-color: $color-primary;
                color: $color-white;
              }
            }

            .disable-save-btn {
              pointer-events: none;
              opacity: 0.5;
            }
          }
        }
      }
    }
  }
}
</style>
